import { Button } from '@/components/shadcn/button'
import { useRestClient } from '@/contexts/QueryProvider'
import { FlowRegular } from '@fluentui/react-icons'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Suspense, useCallback } from 'react'
import { AppCard } from './AppCard'
import { PipelineCardActionsMenu } from './AppCard/PipelineCardActionsMenu'
import { PipelineCardButtons } from './AppCard/PipelineCardButtons'
import AddPipelineFormV2 from '../Forms/AddPipelineFormV2'
import { useCurrentApplication } from '../useCurrentApplication'
import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { LoadingComponent } from '@/components/ui/LoadingComponent'

export const AppPipelinesSection = () => {
  const { applicationId, appName } = useCurrentApplication()
  const { getPipelineApiGetPipeline } = useRestClient()

  const invalidatePipelines = useCallback(() => {
    getPipelineApiGetPipeline.invalidateQueries({ parameters: { path: { applicationId } } })
  }, [applicationId, getPipelineApiGetPipeline])

  return (
    <SectionContainer
      title="Pipelines"
      action={
        <AddPipelineFormV2
          sheetTitle={`${appName} > Add pipeline`}
          sheetDescription="Add a new pipeline to your application."
          sheetTriggerTooltip="Add pipeline"
          mode="pipeline"
          onSubmit={invalidatePipelines}
          sheetTrigger={
            <Button variant="ghost" size="icon">
              <IconPlusOutline />
              <span className="sr-only">Add pipeline</span>
            </Button>
          }
        />
      }
    >
      <QueryErrorBoundary errorMessage="Failed to fetch pipelines">
        <Suspense fallback={<LoadingComponent text="Loading pipelines..." />}>
          <AppPipelinesList />
        </Suspense>
      </QueryErrorBoundary>
    </SectionContainer>
  )
}

function AppPipelinesList() {
  const { applicationId } = useCurrentApplication()
  const { getPipelineApiGetPipeline } = useRestClient()

  const { data: pipelines } = getPipelineApiGetPipeline.useSuspenseQuery({
    path: { applicationId },
  })

  return (
    <div className="grid w-full grid-cols-[repeat(auto-fill,minmax(350px,1fr))] gap-1">
      {pipelines?.map((pipeline) => (
        <AppCard
          key={pipeline.id}
          icon={<FlowRegular fontSize={34} />}
          name={pipeline.name || 'no name'}
          description={pipeline.description || 'no description'}
          cardMenu={<PipelineCardActionsMenu pipeline={pipeline} />}
          cardButtons={<PipelineCardButtons pipeline={pipeline} />}
        />
      ))}
    </div>
  )
}
